export default __webpack_public_path__ + "static/media/brandontext-bold.2c43a000.ttf";